<template lang="html">
  <div class="">

    <div class="select-question select-question_answer-select-question container">
      <div class="select-question__left flex-grow-2 flex-basis-600">
        <div class="video animation-bottom">
          <video ref="video"
               :src="exercise.video"
               @playing="playing = true"
               @pause="playing = false"
               @timeupdate="timeUpdated($event.target)"/>
          <div class="video__button" v-if="!playing && first">
            <img src="@/assets/img/video-play.svg" @click="play()" class="image-btn">
          </div>
          <div class="video__button container column align-items-center color-white" v-if="!playing && !first">
            <img src="@/assets/img/icons/replay.svg" @click="replay()" class="image-btn">
            <span class="margin-top-10">REPLAY</span>
            <div class="video__button__alert margin-top-30 justify-content-center align-items-center">
              <img src="@/assets/img/icons/alert-video.svg">
              <span>Responda para continuar!</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select-question__right flex-grow-1 flex-basis-500">
        <div class="select_question container align-center">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds">
          </div>
          <div class="flex-grow-1">
            <p>{{ question.question }}</p>
          </div>
        </div>
        <ul class="list-none relative">
          <div class="block__game" v-if="finish"></div>
          <li v-for="(x, ind) in question.answers" class="animation-bottom" :style="{animationDelay: (ind / 20) + 's'}" :key="ind">
            <div
              class="select-question__item container align-items-center"
              @click="selectQuestion(x)"
              :class="{ correct : question.answered && x.correct, wrong: question.answered && !x.correct && x.selected, clicked: x.selected}"
              ref="options"
            >
              <div class="index">
                {{ind + 1}}
              </div>
              {{x.text}}
            </div>
          </li>
        </ul>
      </div>

    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="verify(question)" v-show="showFeedback"/>
        </transition>
        <div v-if="verify(question) && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!verify(question) && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
      </div>
      <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
        <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
      </modal>
    </div>
</template>

<script>
  import gameFeedback from '@/components/game/feedback'
  import modal from '@/components/modal'
  import modalBus from '@/components/modal/modalBus'
  import modalSubTopic from '@/components/modal/modalSubTopic'
  import gameBus from '@/components/game/gameBus'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      gameFeedback,
      modal,
      modalSubTopic
    },
    data() {
      return {
        selectedQuestion: null,
        finish: false,
        showFeedback: false,
        clicks: 0,
        question: {},
        ended: false,
        index: 0,
        showInfo: false,
        oldTime: null,
        currentTime: null,
        playing: false,
        first: true
      }
    },
    props: {
      'topic': {
        type: Object,
        default: () => new Object()
      },
      'subTopic': {
        type: Object,
        default: () => new Object()
      }
    },
    computed: {
      ...mapGetters({
        testMode: 'isTestMode',
        isReview: 'isReview',
        isSpeakUp: 'isSpeakUp',
        student: 'student/GET',
      }),
      exercise () {
        return this.subTopic.exercise
      }
    },
    methods: {
      async selectQuestion (answer) {
        if (!this.question.answered && !this.playing && !this.first) {
          answer.selected = true
          this.question.answered = true
          if (answer.correct) this.question.hit = true
          else this.question.hit = false
          this.$set(this.exercise.questions, this.index, this.question)
          this.feedback()
          await this.save(this.question)
        }
      },
      async feedback () {
        this.showFeedback = true
        await this.$delay(1500)
        this.showFeedback = false
        gameBus.$emit('setEnabled', true)
      },
      verify (question) {
        if (question.answers) {
          const correctIndex = question.answers.findIndex(x => x.correct)
          if (question.answers[correctIndex].selected) return true
        }
        return false
      },
      setCurrent () {
        let qst          = {},
            currentIndex = 0
        const questions = this.exercise.questions.sort((a, b) => a.time - b.time)
        for (const index in questions) {
          currentIndex = index
          if (!questions[index].answered) {
            qst = questions[index]
            break
          }
          if (parseInt(index) == (questions.length - 1)) {
            qst = questions[index]
            this.ended = true
          }
        }
        this.index = currentIndex
        if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
          if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
          this.$set(this, 'question', qst)
        }

        setTimeout(() => {
          gameBus.$emit("setEnabled", this.question.answered);
        }, 1000)
      },
      next () {
        if (this.first) this.first = false
        this.setCurrent()
        this.$refs['video'].play()
      },
      async save (question) {
        let scoreQuestions = 0,
            answered       = 0

        for (const qst of this.exercise.questions) {
          for (const aswr of qst.answers) {
            if (aswr.selected && aswr.correct) scoreQuestions++
          }
          if (qst.answered) answered++
        }

        const score = (scoreQuestions * 100)/this.exercise.questions.length
        let payload = {
          points: score,
          finished: false,
          question: { ...question }
        }

        if (answered == this.exercise.questions.length) {
          payload.finished = true
          this.ended = true
          await this.$delay(1500)
          this.showInfo = true
        }

        gameBus.$emit('updateProgress', score)

        if (!!this.student.teens) {
          await this.$store.dispatch('teens/answerQuestion', payload)
          return
        }

        if (this.isSpeakUp) {
          await this.$store.dispatch("speakup/answerQuestion", {
            ...this.$route.params,
            ...payload
          })
          return
        }

        if (!this.testMode && !this.isReview)
          await this.$store.dispatch('subTopic/answerQuestion', payload)
      },
      timeUpdated (video) {
        const time = video.currentTime
        if (this.oldTime === null) this.oldTime = time
        else this.oldTime = this.currentTime
        this.currentTime = time
        if ((this.question.time >= this.oldTime) && (this.question.time <= this.currentTime)) {
          if (this.first) this.first = false
          this.$refs['video'].pause()
        }
      },
      closeModal () {
        this.showInfo = false
      },
      emitClose () {
        this.$refs['modal'].close()
      },
      play () {
        if (this.first) {
          this.$refs['video'].pause()
          this.$refs['video'].play()
        }
      },
      replay () {
        if (this.index == 0) this.$refs['video'].currentTime = 0
        else this.$refs['video'].currentTime = this.exercise.questions[this.index - 1].time
        this.$refs['video'].play()
      },
      async viewQuestion (index) {
        const question = this.exercise.questions[index]
        if (question && question.answered) {
          this.index = index
          this.$set(this, 'question', question)
        }
      }
    },
    watch: {
      ended (val) {
        gameBus.$emit('setEnded', val)
      },
      index (val) {
        gameBus.$emit('updateIndex', val)
      }
    },
    async mounted () {
      this.setCurrent()
      gameBus.$on('viewQuestion', this.viewQuestion)

      gameBus.$emit('updateProgress', this.subTopic.points)
      modalBus.$on('close', this.closeModal)
      gameBus.$on('setCurrent', this.next)
    },
    beforeDestroy () {
      gameBus.$off('viewQuestion', this.viewQuestion)

      modalBus.$off('close', this.closeModal)
      gameBus.$off('setCurrent', this.next)
    }
  }
</script>

<style lang="scss">
  @import './src/assets/css/components/selectQuestion';
  @import './src/assets/css/components/answerSelectQuestion';
  @import './src/assets/css/base/variables';

  .video {
    &, video {
      width: 100%;
      height: 100%;
      min-height: 250px;
      position: relative;
    }
    &__button {
      top: 0;
      position: absolute;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100%;
      background-color: rgba(#000, .5);
      border-radius: 17.5px;
      border: none;
      & img.image-btn {
        align-self: center;
        transition: all .15s ease;
        border: 0px solid #ddd;
        border-radius: 150px;
        &:hover {
          transform: scale(1.1);
          cursor: pointer;
          border: 15px solid rgba(#ddd, .5);
        }
      }
      &__alert {
        display: flex;
        width: 265px;
        height: 55px;
        border-radius: 35px;
        background-color: $color-yellow;
        padding-right: 10px;
        img {
          height: 100%;
          margin-top: 11px;
          margin-right: 7px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/game/videoSelectQuestion.vue